module.exports = __webpack_public_path__ + "static/media/pe-icon-set-weathere60d.bb4266d9.svg";